export enum NavGroups {
  Administration = 'Administration',
  Views = 'Views',
  CustomData = 'Custom Data',
  EnterpriseData = 'Enterprise Data',
  ManagedData = 'Managed Data'
}
